export default "__VITE_ASSET__BXZQAeOC__"